import Image from 'next/image';
import xw from 'xwind';
import { MRB } from '@/types/MRB';
import TextEditorHTML from '@/components/TextEditorHTML';
import { CardWrapper } from './SpecialistCard.styles';
import { SpecialCardAccordion } from '../widgets';

const SpecialistCard = ({ bio, image, name, title }: MRB): JSX.Element => {
  return (
    <CardWrapper>
      <div css={xw`h-auto md[w-1/4 pr-8]`}>
        {image && (
          <Image
            src={image}
            alt="Picture of the author"
            width={264}
            height={278}
            objectFit="cover"
            unoptimized
          />
        )}
      </div>
      <div css={xw`md:w-3/4`}>
        <h2 css={xw`text-2xl md:text-3xl text-gray-800`}>{name}</h2>
        <span css={xw`text-base md:text-xl text-gray-400`}>{title}</span>
        <SpecialCardAccordion id={name}>
          <TextEditorHTML items={bio?.all} bodyStyle="body1" />
        </SpecialCardAccordion>
      </div>
    </CardWrapper>
  );
};

export default SpecialistCard;
